import { render, staticRenderFns } from "./header-form-item.vue?vue&type=template&id=558e3386&scoped=true&"
import script from "./header-form-item.vue?vue&type=script&lang=js&"
export * from "./header-form-item.vue?vue&type=script&lang=js&"
import style0 from "./header-form-item.vue?vue&type=style&index=0&id=558e3386&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "558e3386",
  null
  
)

export default component.exports